import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_REVENUE, SUPERSET_REVENUE_ERROR, SUPERSET_REVENUE_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetRevenue({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_REVENUE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_REVENUE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_REVENUE_ERROR, payload: error });
  }
}

export function* watchSupersetRevenue() {
  yield takeEvery(SUPERSET_REVENUE, supersetRevenue);
}

function* supersetRevenueSaga() {
  yield all([fork(watchSupersetRevenue)]);
}

export default supersetRevenueSaga;
